/* Manages user identity data in the client side */
angular.module('identity', ['config', 'utils'])
